import React from 'react'
import { Link } from 'react-router-dom'
import { ProductHandler } from 'utils'
import defaultLabImage from 'assets/img/default/default-lab.png'


const checkSelect = (product, selectedTags) => {
	const selectedTag = selectedTags[0];

	let selected = selectedTag === 'all';

	if (!product.tags) { return selected; }

	for (let i = 0; i < product.tags.length; i++) {
		if (product.tags[i].name === selectedTag) {
			selected = true;

			break;
		}
	}

	return selected;
}

export default class ProductBox extends React.PureComponent {
	onSingleAdd = (e) => {
		e.preventDefault();

		const {
			product,
			authenticated,

			history,

			onUserOrdersAddRequest,
			onModalOpen,
		} = this.props;
		const list = [{ id: product.id, plan: product.plans[0].id }];

		if (authenticated) {
			onUserOrdersAddRequest({ products: list, paymentType: 'free' });
			onModalOpen('add-single');
		} else {
			history.push('/login-page');
		}
	}

	ProductTop = (product) => (
		<div className='product-top'>
			<div
				className={`${!product.avatar_small ? 'opacity-80' : ''} frame`}
				style={{ backgroundImage: `url(${product.avatar_small ? product.avatar_small.url : defaultLabImage})` }}
			/>
		</div>
	)

	ProductBottom = (product) => {
		const { id, type, name, owned, info_short } = product;
		const isSingle = type === 'single';
		const isOwned = owned === 1;
		const isMobile = this.props.isMobile;

		return (
			<div
				className='product-bottom'
				data-id={id}
				onClick={(isMobile && isSingle && !isOwned) ? this.onSingleAdd : null}
			>
				<div className='product-detail'>
					<h3 className='product-name margin-top-0'>{name}</h3>

					{(isMobile && !isOwned) && (
						<span className={`mobile-detail ${isSingle ? 'disabled' : 'margin-right-10'}`}>
							<i className={`${isSingle ? 'elegant-eleganticons-43' : 'fas fa-chevron-right'}`}/>
						</span>
					)}

					<div className='product-description'>{info_short}</div>
				</div>

				<button
					className={`ua-btn ${isOwned ? 'outline disabled' : 'book-submit submit default'} w-100`}
					data-id={id}
					onClick={(isSingle && !isOwned) ? this.onSingleAdd : null}
				>
					{isSingle ? isOwned ? '已新增' : '新增套件' : '詳情'}
				</button>
			</div>
		);
	}

	render() {
		const { product, selected_tags } = this.props;
		const isSelect = checkSelect(product, selected_tags);

		return isSelect
			? (
				<article className='product-box'>
					<div className='product-content ua-box default clearfix animated fadeIn'>

						{(product.type === 'single')
							? this.ProductBottom(product)
							: (
								<Link to={`/e-com/product-detail/${ProductHandler.getProductID(product)}`}>
									{this.ProductTop(product)}

									{this.ProductBottom(product)}
								</Link>
							)
						}

					</div>
				</article>
			)
			: null;
	}
}
